import $ from 'jquery';
import Flickity from 'flickity';
import layout from '../Layout';
import ProductItem from './ProductItem';

export default class ProductHighlights {
  constructor(el, postMessage) {
    this.el = el instanceof $ ? el[0] : el;
    this.$el = el instanceof $ ? el : $(el);
    this.postMessage = postMessage;
    this.onBreakpointChange = this._onBreakpointChange.bind(this);
    this.productItems = [];

    this._load();
  }

  onSectionMessage(name, data) {
    // propogate through productItems, for use by quickshops
    this.productItems.forEach(productItem => productItem.onSectionMessage(name, data));
  }

  reload() {
    this.unload();
    this._load();
  }

  unload() {
    layout.offBreakpointChange(this.onResize);
    this.productItems.forEach(productItem => productItem.unload());
  }

  _unloadFlickity() {
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null;
      $('[data-product-item]', this.$el).attr('style', '');
    }
  }

  _loadFlickity() {
    const container = this.el.querySelector('.product-highlights-mobile-wrapper');

    if (!container) {
      return;
    }

    if (!this.flickity) {
      this.flickity = new Flickity(container, {
        cellSelector: '[data-product-item]',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        selectedAttraction: 0.02,
      });
    }
  }

  _load() {
    $('[data-product-item]', this.$el)
      .each((index, productItem) => {
        this.productItems.push(new ProductItem($(productItem), this.postMessage));
      });

    layout.onBreakpointChange(this.onBreakpointChange);

    if (layout.isBreakpoint('S', 'M')) {
      this._loadFlickity();
    }
  }

  _onBreakpointChange() {
    if (layout.isBreakpoint('M') || layout.isBreakpoint('S')) {
      this._loadFlickity();
    } else {
      this._unloadFlickity();
    }
  }
}
